import * as React from "react";
import { Modal } from "Components/General/Modal/GenericModal";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { collectionFolderStore } from "./CollectionFolderStore";
import { observer } from "mobx-react";
import { ProjectFilesTable } from "./ProjectFilesTable";
import { CollectionFilesTable } from "./CollectionFilesTable";
import { CollectionFolderFile } from "./interfaces";

interface CollectionFolderProps extends WithTranslation {}

export const CollectionFolder = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<CollectionFolderProps> {
      componentDidMount() {
        this.init();
      }

      init = async () => {
        try {
          await collectionFolderStore.init();
        } catch (error) {
          throw error;
        }
      };

      handleAddFiles = (files: CollectionFolderFile[]) => {
        collectionFolderStore.addFiles(files);
        collectionFolderStore.toggleProjectFiles();
      };

      render() {
        const { t } = this.props;
        return (
          <Modal
            title={t("Collection folder")}
            open={collectionFolderStore.isVisible}
            width="100%"
            className="full-height-modal"
            style={{ maxWidth: 1200 }}
            footer={null}
            onCancel={collectionFolderStore.toggleModal}
            maskClosable={true}
          >
            {collectionFolderStore.showProjectFiles ? (
              <ProjectFilesTable
                onBack={collectionFolderStore.toggleProjectFiles}
                initialValue={collectionFolderStore.data.slice()}
                onAddFiles={this.handleAddFiles}
                // scroll={{ x: 1000 }}
              />
            ) : (
              <CollectionFilesTable
                loading={collectionFolderStore.state === "LOADING"}
                onDelete={collectionFolderStore.removeFile}
                onClearAll={collectionFolderStore.clearAll}
                toggleFilesPicker={collectionFolderStore.toggleProjectFiles}
                data={collectionFolderStore.data.slice()}
              />
            )}
          </Modal>
        );
      }
    }
  )
);
